module.exports = __webpack_public_path__ + "img/flag-en.af21faca.png";